import { Box, styled, Typography } from "@mui/material";
import { useState } from "react";

const PointerSpan = styled("span")({
  cursor: "pointer"
});
function ReadMoreText({
  className,
  text,
  maxChars,
  readMoreText = "read more",
  readLessText = "read less",
  sx,
  ...rest
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const hasReadMore = text ? (text.length > maxChars ? true : false) : false;
  const textSx = [
    {
      whiteSpace: "pre-wrap",
      overflowWrap: "anywhere",
      wordBreak: "break-word"
    },
    ...(Array.isArray(sx) ? sx : sx ? [sx] : [])
  ];

  return (
    <Box className={className} sx={{ minWidth: 0, width: "100%", maxWidth: "100%" }}>
      {text && (isExpanded || !hasReadMore) && (
        <Typography variant="body2" {...rest} sx={textSx}>
          {text}{" "}
          {hasReadMore && !!isExpanded && (
            <PointerSpan onClick={() => setIsExpanded(false)}>
              <strong>{readLessText}</strong>
            </PointerSpan>
          )}
        </Typography>
      )}
      {text && !isExpanded && !!hasReadMore && (
        <Typography variant="body2" {...rest} sx={textSx}>
          {text.slice(0, maxChars)}...{" "}
          <PointerSpan onClick={() => setIsExpanded(true)}>
            <strong>{readMoreText}</strong>
          </PointerSpan>
        </Typography>
      )}
    </Box>
  );
}

export default ReadMoreText;
